import axiosClient from "utils/api/axios-client";

const restaurantLabelApi = {
  getAll: (params) => {
    const url = "/api/v1/restaurant-labels";
    return axiosClient.get(url, { params });
  },
  get: (id) => {
    const url = `/api/v1/restaurant-labels/${id}`;
    return axiosClient.get(url);
  },
  create: (restaurantLabel) => {
    const url = `/api/v1/restaurant-labels/`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.post(url, restaurantLabel, config);
  },
  update: (id, restaurantLabel) => {
    const url = `/api/v1/restaurant-labels/${id}`;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axiosClient.put(url, restaurantLabel, config);
  },
  delete: (id) => {
    const url = `/api/v1/restaurant-labels/${id}`;
    return axiosClient.delete(url);
  },
};

export default restaurantLabelApi;
